import React, { useContext, useEffect, useState } from 'react';
import Popover from '../../../UI/Popover/Popover';
import Attachment from "../../../../assets/Icon/Attachment"; 
import cl from './InvoiceModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import { baseFileURL } from '../../../../Api';
import BLicon from "../../../../assets/Icon/BLicon";


const InvoiceModal = ({ containerService, defaultContainer }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [invoiceId, setInvoiceId] = useState(defaultContainer.company_invoice_doc_id); 

    const [container, setContainer] = useState(defaultContainer);
    const { appState, app } = useContext(AppContext);
    var pecent = 0

    useEffect(() => {
        setContainer(containerService)
    }, [containerService]);

    const handleChange = (event) => { 
        setInvoiceId(event.target.value);
    };

 
    const onUpdateClick = (event) => {
        const newForm = new FormData();
        newForm.append('container_id', defaultContainer.id);
        if (file) {
            newForm.append('invoice', file);
        }

        newForm.append('invoice_id', invoiceId);

        containerService.uploadInvoice(newForm)
            .then(response => {
                containerService.fetchList()
            })
            .catch(error => {
                console.error(error);
            });   
         
        setIsModalOpen(false) 
    };

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/;

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    return ( 
            <Popover placement='bottom' fullWidth={true} content={<>
                    <div style={{ minWidth: '200px' }} >
                        <div className={cl.modalHead} >
                            <h3>
                                <span className={cl.iconHead  } > <BLicon /></span>
                                <div style={{ display: 'flex', flexDirection: 'column' }}> 
                                    <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600 }}> Bill of Landing</div> 
                                </div> 
                            </h3>
                        </div>

                        <div>  
                            <div className={cl.groupInput} style={{ display: 'none' }}>
                                <label>Invoice Id</label>
                                <div className={cl.inputDiv}>
                                    <input type="text"  name="company_invoice_doc_id" className={cl.input} value={invoiceId} onChange={handleChange}   />
                                </div>
                            </div>
        
                            <div className={cl.groupInput}> 
                                <div className={cl.inputDiv + ' ' + cl.uploadDiv}>
                                    <input type="file" name="invoice " className={cl.input}  onChange={e => setFile(e.target.files[0])} />
                                </div>
                            </div>
        
                            { defaultContainer.company_invoice_doc && defaultContainer.company_invoice_doc.length > 0 &&
                                <a className={ cl.link2ed} href={baseFileURL + defaultContainer.company_invoice_doc} target='_blank' rel="noopener noreferrer">
                                    <Attachment props={{ height: '200px' }} /> BL გადმოწერა
                                </a> 
                            }

                            <div className={cl.flexend}>
                                <button type="submit"  onClick={(event) => {
                                        onUpdateClick();
                                        event.stopPropagation(); // Prevents the popover from toggling when the button inside it is clicked
                                        event.target.closest('div[style*="position: absolute"]').previousSibling.click(); // Simulates clicking the trigger to close
                                    }} className={cl.btnPrimary} >შენახვა
                                </button>
                            </div>  
                        </div>
                    </div> 
                </>}>
 
                {defaultContainer.company_invoice_doc && defaultContainer.company_invoice_doc.length > 0 ? (
                    <div style={{display: 'flex', width: '100%'}}>

                        <span className={cl.btnContainerTop +' '+ cl.greenbtn}>
                            <span className={cl.icon  }><BLicon/> </span>
                            <div className={cl.btnTxt }  style={{ width: '100%'}}>Bill of Landing</div> 
                            <a className={ cl.linkinvoice } href={baseFileURL + defaultContainer.company_invoice_doc} target='_blank' rel="noopener noreferrer">
                                <Attachment/>  
                            </a>
                        </span>
 
                    </div>
                    
                ) : (
                   
                    <span className={cl.btnContainerTop +' '+ cl.greenbtn}>
                        <span className={cl.icon  }><BLicon/> </span>
                        <div className={cl.btnTxt }  style={{ width: '100%'}}>Bill of Landing</div> 
                    </span>

                )
                }  
            </Popover>  
    );
};

export default InvoiceModal;